import axios from './config/config-viva'

const defaultRoute = 'clientes/'

export default {
    async exportCustomersWhoDeclareIncomeTax() {
      return axios.get(
        `${defaultRoute}export-customers-who-declare-income-tax`
      )
    },
    list: (page=null, limit=null, filter=null, tipoPesquisa=null) => {
        return axios.get(`${defaultRoute}${
            page?'?page='+page:''}${
            limit?'&limit='+limit:''}${
            filter?'&onFilter='+filter:''}${
                tipoPesquisa?'&type='+tipoPesquisa:''   
            }`)
    },
    listBySelect(){
        return axios.get(`${defaultRoute}select`)
    },
    listBySelectByText(text){
        return axios.get(`${defaultRoute}selecttext?text=${text}`)
    },
    listClientsWithInternation(page, limit){
        return axios.get(`${defaultRoute}with-internacao/${
            page?'?page='+page:''}${
            limit?'&limit='+limit:''}`)
    },
    habilitarInternacao(id){
        return axios.get(`${defaultRoute}internacao/${id}`)
    },
    findOne(id){
        return axios.get(`${defaultRoute}one/${id}`)
    },
    uploadImage:(image)=>{
        return axios.post(defaultRoute+'upload',image)
    },
    create: (cliente) => {
        return axios.post(defaultRoute, cliente)
    },
    update: (id, user) => {
        return axios.put(defaultRoute+id, user)
    },
    remove: (id) => {
        return axios.delete(defaultRoute+id)
    },
    updateStatus:(id, status)=>{
        return axios.put(`${defaultRoute}update-status/${id}`, {status})
    },
}